import { UseMutationOptions, useMutation } from '@tanstack/react-query';
import { App } from 'antd';
import { AxiosError } from 'axios';

import { axiosClient } from '@/lib/axios';

export const purchasePackage = async ({
  packageID,
  companyID,
  code,
}: {
  packageID: number;
  companyID: number;
  code?: string;
}): Promise<{ redirect_url: string }> => {
  const { data } = await axiosClient.put<{ redirect_url: string }>(
    `/premium/${companyID}/packages/${packageID}/subscribe`,
    { code },
  );
  return data;
};

type UsePurchasePackageOptions = {
  config?: Partial<
    UseMutationOptions<{ redirect_url: string }, AxiosError<{ message: string }>, { packageID: number }>
  >;
  handleAfterFailure: (code?: number) => void;
};

export const usePurchasePackage = ({ config, handleAfterFailure }: UsePurchasePackageOptions) => {
  const { notification: toaster } = App.useApp();
  return useMutation({
    onError: (error) => {
      toaster.error({
        message: 'Something Went Wrong',
        description: error.response?.data.message,
      });
      handleAfterFailure(error.response?.status);
    },
    ...config,
    mutationFn: purchasePackage,
  });
};
